import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDateField, CheckBox, DBDropDown, CopyButton } from '_components';
import { getDateMMDDYYYY } from '_helpers';
import styles from './Common.module.css';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';

class PatientCareCenterNoteGoalsIndHep extends React.Component {

    uncheck() {
        this.props.removeChildRow(this.props.noteId, 'PTGOALS', 'GO', this.props.goal.GONO);
    }

    check() {
        this.props.addIndHepGoal(this.props.noteId, 'PTGOALS', 'GO', 'GO' + this.props.prefix + 'NO', this.props.pk);
    }

    copyProgress() {
        this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGPNO', this.props.goal.GOGPNOPREV);
    }

    render() {
        return (
            <div>
                <PatientCareCenterNoteNavAnchor id={'ind_hep_' + (this.props.goal ? this.props.goal.GONO : '')} />
                {this.props.goal &&
                    <span className={styles.ind_hep_wrapper}>
                        <CheckBox
                            size='extra-small'
                            className={styles.checkbox}
                            checked={true}
                            title={'Independence with Home Program'}
                            label={'Independence with Home Program'}
                            onClick={() => this.uncheck()}
                            disabled={this.props.disabled}
                        />
                        <span className={this.props.disabled ? styles.goal_ind_hep_label : styles.goal_ind_hep_label_req}>Date:</span>
                        <span className={styles.goal_ind_hep_date}>
                            <DBDateField
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GODATE'
                                customMsg='The goal date cannot be in the past.'
                                minDate={getDateMMDDYYYY(new Date())}
                                disabled={this.props.disabled}
                            />
                        </span>
                        {this.props.noteType !== 1 &&
                            <>
                                <span className={this.props.goalProgEmpty ? styles.goal_ind_hep_prog_req : styles.goal_ind_hep_prog}>Progress:</span>
                                <span className={styles.goal_ind_hep_prog_dropdown}>
                                    <DBDropDown
                                        className={styles.goal_level_dropdown}
                                        noteId={this.props.noteId}
                                        entity='PTGOALS'
                                        entityKeyColumn='GONO'
                                        entityKeyValue={this.props.goal.GONO}
                                        field='GOGPNO'
                                        masterEntity='PTMASTERGOALPROGRESS'
                                        masterEntityKeyColumn='GPNO'
                                        masterEntitySort='GPORDER'
                                        masterEntityDisplay='GPNAME'
                                    />
                                    {(this.props.noteType === 3 || this.props.noteType === 5) &&
                                        <CopyButton size='extra-small' title='Copy value from most recent note' onClick={() => this.copyProgress()} />
                                    }
                                </span>
                            </>
                        }
                    </span>
                }
                {!this.props.goal &&
                    <span className={styles.ind_hep_wrapper}>
                        <CheckBox
                            size='extra-small'
                            className={styles.checkbox}
                            checked={false}
                            title={'Independence with Home Program'}
                            label={'Independence with Home Program'}
                            onClick={() => this.check()}
                            disabled={this.props.disabled}
                        />
                    </span>
                }
            </div >
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        addIndHepGoal: bindActionCreators(noteActions.addIndHepGoal, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let prefix = noteType === 1 ? 'EV' : 'NT';
    let disabled = noteType === 2 || noteType === 4 || noteType === 6;

    let goals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return ((noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)) &&
                (state.entities.notes.PTGOALS[key].GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE))
        })
        .map(key => state.entities.notes.PTGOALS[key]);

    let goal = goals && goals.length > 0 ? goals[0] : undefined;

    if (goal) {
        if (disabled && !goal.GODATE) {
            disabled = false;
        }
    }


    let goalProgEmpty = false;
    if (goal !== undefined) {
        if (goal.GOGPNO !== undefined) {
            goalProgEmpty = goal.GOGPNO ? false : true;
        }
    }


    return {
        noteId,
        noteType,
        pk,
        goal,
        prefix,
        disabled,
        goalProgEmpty,
    };
}

const connectedPatientCareCenterNoteGoalsIndHep = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsIndHep);
export { connectedPatientCareCenterNoteGoalsIndHep as PatientCareCenterNoteGoalsIndHep };

